import {
  CLEAR_CHILDREN_DETAIL,
  SET_CHILDREN_DETAIL,
  SET_LIST_DATES_HAS_EVALUATION,
  SET_LIST_DATES_HAS_VIDEO,
  SET_LIST_VIDEO,
  SET_CREATE_REPORT_DATA,
} from 'store/types/children';

export const setChildrenDetail = (childrenDetail) => {
  return {
    type: SET_CHILDREN_DETAIL,
    payload: childrenDetail,
  };
};

export const clearChildrenDetail = () => {
  return {
    type: CLEAR_CHILDREN_DETAIL,
    payload: null,
  };
};

export const setListVideo = (listVideo) => {
  return {
    type: SET_LIST_VIDEO,
    payload: listVideo,
  };
};

export const setListDatesHasVideo = (listDatesHasVideo) => {
  return {
    type: SET_LIST_DATES_HAS_VIDEO,
    payload: listDatesHasVideo,
  };
};

export const setListDatesHasEvaluation = (listDatesHasEvaluation) => {
  return {
    type: SET_LIST_DATES_HAS_EVALUATION,
    payload: listDatesHasEvaluation,
  };
};

export const setCreateReportData = (createReportData) => {
  return {
    type: SET_CREATE_REPORT_DATA,
    payload: createReportData,
  };
};
